export const UPDATE_ACTIVITY_STATUS = 'UPDATE_ACTIVITY_STATUS';
export const UPDATE_INACTIVITY_PERIOD = 'UPDATE_INACTIVITY_PERIOD';
